import { render, staticRenderFns } from "./ComptaFund.vue?vue&type=template&id=50860a54&scoped=true&"
import script from "./ComptaFund.vue?vue&type=script&lang=js&"
export * from "./ComptaFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50860a54",
  null
  
)

export default component.exports